function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSsangyong({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_1",
    x: "0px",
    y: "0px",
    viewBox: "28.251 162.332 503.946 74.439",
    style: {
      enableBackground: "new 0 0 560 400"
    },
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M96,231.8c2.6-1.8,4.4-1.6,6.7-3.9c2.1-2.1-0.8-4.6-2.9-6.1c-2.3-1.7-0.9-2,2-2.6c8.3-1.6,19.3-4.3,23.9-5.6 c11.5-3.2,21.6-11.3,21.5-20.6c-0.1-6.3-4.5-11.8-9.2-15.6c-4.7-3.8-9.7-6.1-11.3-6.5c-3.3-1-1.6,1.2-1.6,1.2s3,1.1,9.2,5.7 c4.6,3.4,9,8.7,9,14.4c0.1,14.8-20,19.2-20,19.2s18.3-5.4,18.1-19.2c-0.1-5.9-6.3-13.5-14.7-19.1c-6.2-4.1-13.4-6.4-14.9-6.6 c-4.3-0.7-2.2,1.4-2.2,1.4s5.7,1.4,13,6.4c6,4.1,11.7,10.7,11.8,18.4c0.1,9.9-9.8,15-14.2,17.2c-6.7,3.3-13.9,5-13.9,5 s8.2-2.2,14.8-6.3c6-3.8,11.2-10.2,11.1-15.9c-0.1-10.6-11.2-19-20.5-23.8c-4.9-2.6-9.4-4.1-11.3-4.5c-2.2-0.5-5.3-0.6-1.6,1.7 c2.7,1.7,6.6,4.2,9.8,7.2c5.9,5.4,11.1,13,11.2,19.8c0.1,8.8-5.9,15.7-12.6,18.4c-6.1,2.5-12,3.2-13.9,3.5 c-2.8,0.6-2.6,2.9-2.2,3.4c1.4,1.7,5,3,5,6c0,5.1-6.9,5.7-7.7,5.7c-0.8,0-7.7-0.6-7.7-5.7c0-3,3.6-4.3,5-6c0.4-0.5,0.6-2.9-2.2-3.4 c-1.9-0.4-7.8-1.1-13.9-3.5c-6.7-2.7-12.6-9.6-12.6-18.4c0.1-6.9,5.3-14.4,11.2-19.8c3.2-3,7.1-5.5,9.8-7.2 c3.7-2.3,0.6-2.2-1.6-1.7c-1.9,0.4-6.4,1.9-11.3,4.5c-9.3,4.8-20.4,13.2-20.5,23.8c-0.1,5.7,5.2,12.1,11.1,15.9 c6.5,4.1,14.8,6.3,14.8,6.3s-7.2-1.7-13.9-5c-4.4-2.2-14.3-7.3-14.2-17.2c0.1-7.7,5.8-14.3,11.8-18.4c7.3-5,13-6.4,13-6.4 s2.1-2.1-2.2-1.4c-1.5,0.2-8.7,2.5-14.9,6.6c-8.4,5.5-14.6,13.2-14.7,19.1c-0.1,13.8,18.1,19.2,18.1,19.2s-20.2-4.4-20-19.2 c0.1-5.7,4.4-10.9,9-14.4c6.3-4.7,9.2-5.7,9.2-5.7s1.7-2.2-1.6-1.2c-1.6,0.5-6.6,2.7-11.3,6.5c-4.7,3.8-9.2,9.3-9.2,15.6 c-0.1,9.3,10,17.5,21.5,20.6c4.6,1.3,15.6,4,23.9,5.6c2.9,0.6,4.3,0.9,2,2.6c-2.1,1.6-5,4.1-2.9,6.1c2.3,2.3,4.2,2.1,6.7,3.9 c2.6,1.8,3.5,3.9,7.4,3.9C92.6,235.7,93.5,233.6,96,231.8",
    style: {
      fill: "rgb(1, 16, 89)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.2,211.9c0-7.8-4.3-11.5-13.5-15.3c-6.7-2.8-11.7-4.7-11.7-9.5c0-1.6,0.4-6.5,9.7-6.5c7.7,0,13.3,3.3,13.3,3.3v-8.3 c0,0-6.6-2.4-14-2.4c-19.7,0-20.1,12.4-20.1,14.6c0,9.1,7.2,12.4,16,15.6c2.3,0.8,9.6,2.8,9.6,8.5c0,2.2-1.3,7.2-12.3,7.2 c-7,0-12.7-2.9-12.7-2.9v8.4c0,0,4.8,2.4,13.9,2.4C208.6,226.9,213.2,218.1,213.2,211.9",
    style: {
      fill: "rgb(0, 15, 88)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.5,213.6c0-4.6-2.3-7.9-9.7-11.1c-5.4-2.4-10.4-4.5-10.4-8.1c0-1.3,0.7-5.1,7.3-5.1c6.3,0,10.7,3,10.7,3v-7.6 c0,0-4.1-2.3-12.2-2.3c-15.4,0-15.9,10-15.9,11.8c0,6.6,4.5,9.7,10.9,12.4c2.9,1.3,9.2,2.9,9.2,7.7c0,1.8-1.6,5.5-8.9,5.5 c-5.4,0-10.4-2.5-10.4-2.5v7.5c0,0,3.3,1.8,11.2,1.8C238.8,226.7,243.5,219.9,243.5,213.6",
    style: {
      fill: "rgb(0, 15, 88)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.6,183.3h-8.3v30.5l-17.7-30.5h-11.7v42.1h8.3V194l18.3,31.4h11.2V183.3z",
    style: {
      fill: "rgb(0, 15, 88)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.7,225.4h9.1l-3.6-9.5l-2.5-6.5l-10.1-26.1h-11.8l-10.1,26.1l-2.5,6.5l-3.6,9.5h9.1l3.6-9.3h18.9L276.7,225.4z M263.7,191.6l6.9,17.9h-13.8L263.7,191.6z",
    style: {
      fill: "rgb(0, 15, 88)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.9,202v6.2h10.4v10.7c0,0-1.6,1.1-6.2,1.1c-15.1,0-16.1-12.3-16.1-14.8c0-4.9,1.8-9.1,4.5-11.9c2.9-3,7.3-4.2,13.2-4.2 c7.4,0,12.1,2.6,12.1,2.6v-7c0,0-6.2-2.1-13-2.1c-8.2,0-15,2.3-19.7,6.5c-4.2,3.8-6.6,10.4-6.6,16c0,5.2,2.4,21.8,25.3,21.8 c8.7,0,15.6-3.1,15.6-3.1l0-21.7H348.9z",
    style: {
      fill: "rgb(0, 15, 88)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.3,183.3H478v30.5l-17.7-30.5h-11.7v42.1h8.3V194l18.3,31.4h11.2V183.3z",
    style: {
      fill: "rgb(0, 15, 88)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.6,202v6.2H521v10.7c0,0-1.6,1.1-6.2,1.1c-15.1,0-16.1-12.3-16.1-14.8c0-4.9,1.8-9.1,4.5-11.9c2.9-3,7.3-4.2,13.2-4.2 c7.4,0,12.1,2.6,12.1,2.6v-7c0,0-6.2-2.1-13-2.1c-8.2,0-15,2.3-19.7,6.5c-4.2,3.8-6.6,10.4-6.6,16c0,5.2,2.4,21.8,25.3,21.8 c8.7,0,15.6-3.1,15.6-3.1l0-21.7H510.6z",
    style: {
      fill: "rgb(0, 15, 88)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.7,206.8l17.6-32.7h-9.4l-13.1,24.3l-14.2-24.3h-9.6l19.2,32.9L373.3,227h9.4l6.3-11.7L393.7,206.8z",
    style: {
      fill: "rgb(0, 15, 88)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.4,186.6c-4.9-3.7-10.6-4.2-13.6-4.2c-3,0-8.7,0.5-13.6,4.2c-4.5,3.4-9,8.7-9,17.9c0,8.4,3.3,13.3,7.4,17.2 c4.9,4.6,12.9,5.3,15.2,5.3c2.2,0,10.3-0.7,15.1-5.3c4.1-3.9,7.4-8.7,7.4-17.2C446.3,195.3,441.8,190,437.4,186.6 M423.8,220 c-0.5,0-12.9,0.8-12.9-15.5c0-16,12.6-15.4,12.9-15.4c0.3,0,12.9-0.5,12.9,15.4C436.7,220.9,424.3,220,423.8,220",
    style: {
      fill: "rgb(0, 15, 88)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSsangyong);
export default __webpack_public_path__ + "static/media/ssangyong.646ffb19c7505fbd4bb8f640fa786cf8.svg";
export { ForwardRef as ReactComponent };